import React from "react";
import {
  Globe,
  Play,
  Mic,
  AudioLines,
  AlignLeft,
  MessageSquareText,
  Presentation,
} from "lucide-react";
import { ContentType } from "@/types/content";

export const ContentIcon = ({
  type,
  className,
}: {
  type: ContentType;
  className?: string;
}) => {
  const base = "w-4 h-4 text-muted-foreground shrink-0 mr-1 flex items-center justify-center";

  switch (type) {
    case "pdf":
    case "doc":
      return <AlignLeft className={`${base} ${className ?? ""}`} />;

    case "ppt":
      return <Presentation className={`${base} ${className ?? ""}`} />;

    case "youtube":
    case "video":
      return <Play className={`${base} ${className ?? ""}`} />;

    case "web":
      return <Globe className={`${base} ${className ?? ""}`} />;

    case "audio":
      return <AudioLines className={`${base} ${className ?? ""}`} />;

    case "recording":
      return <Mic className={`${base} ${className ?? ""}`} />;

    case "chat":
      return <MessageSquareText className={`${base} ${className ?? ""}`} />;

    case "text":
    default:
      return <AlignLeft className={`${base} ${className ?? ""}`} />;
  }
};
